'use client';

import * as React from 'react';
export const CompositeListContext = /*#__PURE__*/React.createContext({
  register: () => {},
  unregister: () => {},
  map: new Map(),
  elementsRef: {
    current: []
  }
});
if (process.env.NODE_ENV !== 'production') {
  CompositeListContext.displayName = 'CompositeListContext';
}
export function useCompositeListContext() {
  return React.useContext(CompositeListContext);
}